module.exports = __webpack_public_path__ + "static/fireworks-left-4b7536d523e95ccd0804e9ce8961fe25.png";